// This file is auto-generated by @hey-api/openapi-ts

import { client } from './Client.gen';
import type { EshopCompanyControllerGetCompanyCardApplicationsData } from './EshopCompanyControllerGetCompanyCardApplicationsData.gen';
import type { EshopCompanyControllerGetCompanyCardApplicationsErrors } from './EshopCompanyControllerGetCompanyCardApplicationsErrors.gen';
import type { EshopCompanyControllerGetCompanyCardApplicationsResponses } from './EshopCompanyControllerGetCompanyCardApplicationsResponses.gen';
import type { EshopCompanyControllerGetCompanyCustomerCardsData } from './EshopCompanyControllerGetCompanyCustomerCardsData.gen';
import type { EshopCompanyControllerGetCompanyCustomerCardsErrors } from './EshopCompanyControllerGetCompanyCustomerCardsErrors.gen';
import type { EshopCompanyControllerGetCompanyCustomerCardsResponses } from './EshopCompanyControllerGetCompanyCustomerCardsResponses.gen';
import type { EshopCompanyControllerGetCompanyOffensesData } from './EshopCompanyControllerGetCompanyOffensesData.gen';
import type { EshopCompanyControllerGetCompanyOffensesErrors } from './EshopCompanyControllerGetCompanyOffensesErrors.gen';
import type { EshopCompanyControllerGetCompanyOffensesResponses } from './EshopCompanyControllerGetCompanyOffensesResponses.gen';
import type { EshopCompanyControllerGetCompanyTicketFaresData } from './EshopCompanyControllerGetCompanyTicketFaresData.gen';
import type { EshopCompanyControllerGetCompanyTicketFaresErrors } from './EshopCompanyControllerGetCompanyTicketFaresErrors.gen';
import type { EshopCompanyControllerGetCompanyTicketFaresResponses } from './EshopCompanyControllerGetCompanyTicketFaresResponses.gen';
import type { EshopCompanyControllerGetLoggedCompanyData } from './EshopCompanyControllerGetLoggedCompanyData.gen';
import type { EshopCompanyControllerGetLoggedCompanyErrors } from './EshopCompanyControllerGetLoggedCompanyErrors.gen';
import type { EshopCompanyControllerGetLoggedCompanyResponses } from './EshopCompanyControllerGetLoggedCompanyResponses.gen';
import type { EshopCompanyControllerHasActiveCustomerCardData } from './EshopCompanyControllerHasActiveCustomerCardData.gen';
import type { EshopCompanyControllerHasActiveCustomerCardErrors } from './EshopCompanyControllerHasActiveCustomerCardErrors.gen';
import type { EshopCompanyControllerHasActiveCustomerCardResponses } from './EshopCompanyControllerHasActiveCustomerCardResponses.gen';
import type { Options } from './Options.gen';

export class EshopCompanyController {
    /**
     * Get a company info for the logged in account.
     */
    public static getLoggedCompany<ThrowOnError extends boolean = false>(options?: Options<EshopCompanyControllerGetLoggedCompanyData, ThrowOnError>) {
        return (options?.client ?? client).get<EshopCompanyControllerGetLoggedCompanyResponses, EshopCompanyControllerGetLoggedCompanyErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/companies/logged-company',
            ...options
        });
    }
    
    /**
     * Check if company has active customer cards.
     */
    public static hasActiveCustomerCard<ThrowOnError extends boolean = false>(options: Options<EshopCompanyControllerHasActiveCustomerCardData, ThrowOnError>) {
        return (options.client ?? client).get<EshopCompanyControllerHasActiveCustomerCardResponses, EshopCompanyControllerHasActiveCustomerCardErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/companies/{id}/has-active-customer-cards',
            ...options
        });
    }
    
    /**
     * Get ticket fares for a company.
     */
    public static getCompanyTicketFares<ThrowOnError extends boolean = false>(options: Options<EshopCompanyControllerGetCompanyTicketFaresData, ThrowOnError>) {
        return (options.client ?? client).get<EshopCompanyControllerGetCompanyTicketFaresResponses, EshopCompanyControllerGetCompanyTicketFaresErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/companies/{id}/ticket-fares',
            ...options
        });
    }
    
    /**
     * Get customer cards for a company.
     */
    public static getCompanyCustomerCards<ThrowOnError extends boolean = false>(options: Options<EshopCompanyControllerGetCompanyCustomerCardsData, ThrowOnError>) {
        return (options.client ?? client).get<EshopCompanyControllerGetCompanyCustomerCardsResponses, EshopCompanyControllerGetCompanyCustomerCardsErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/companies/{id}/customer-cards',
            ...options
        });
    }
    
    /**
     * Get offenses for a company.
     */
    public static getCompanyOffenses<ThrowOnError extends boolean = false>(options: Options<EshopCompanyControllerGetCompanyOffensesData, ThrowOnError>) {
        return (options.client ?? client).get<EshopCompanyControllerGetCompanyOffensesResponses, EshopCompanyControllerGetCompanyOffensesErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/companies/{id}/offenses',
            ...options
        });
    }
    
    /**
     * Get card applications for a company.
     */
    public static getCompanyCardApplications<ThrowOnError extends boolean = false>(options: Options<EshopCompanyControllerGetCompanyCardApplicationsData, ThrowOnError>) {
        return (options.client ?? client).get<EshopCompanyControllerGetCompanyCardApplicationsResponses, EshopCompanyControllerGetCompanyCardApplicationsErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/companies/{id}/card-applications',
            ...options
        });
    }
}
